import { STORAGE_KEYS } from "Enums";

export const saveAffiliate = (queryString = "") => {
  const queryParams = new URLSearchParams(queryString);
  if (!queryParams.size) {
    return;
  }
  if (queryParams.has("consultant")) {
    const consultantId = queryParams.get("consultant");
    localStorage.setItem(STORAGE_KEYS.affiliateConsultant, consultantId);

  }
  if (queryParams.has("partner")) {
    const partnerId = queryParams.get("partner");
    localStorage.setItem(STORAGE_KEYS.affiliatePartner, partnerId);
  }
};

export const getAffiliate = () => {
  const consultantId = localStorage.getItem(STORAGE_KEYS.affiliateConsultant);
  const partnerId = localStorage.getItem(STORAGE_KEYS.affiliatePartner);
  return { consultantId, partnerId };
};

export const removeAffiliate = () => {
  localStorage.removeItem(STORAGE_KEYS.affiliateConsultant);
  localStorage.removeItem(STORAGE_KEYS.affiliatePartner);
};
